import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ListadoDeSolicitudesQueTieneUnaCoincidenciaNoExacta from './ListadosDeFallecidos/QueTieneUnaCoincidenciaNoExacta'
import ListadoDeSolicitudesQueTienenUnaCoincidenciaExacta from './ListadosDeFallecidos/QueTienenUnaCoincidenciaExacta'
import ListadoDeSolicitudesQueNoTienenCoincidenciasDentroDelPadron from './ListadosDeFallecidos/QueNoTienenCoincidenciasDentroDelPadron'
import ListadoProcesadosEmpadronados from './ListadosDeFallecidos/ListadoProcesadosEmpadronados'
import ListadoProcesadosNoEmpadronados from './ListadosDeFallecidos/ListadoProcesadosNoEmpadronados'
import ListadoDeRegistrosEliminadosDeOrigenSistema from './ListadosDeFallecidos/ListadoDeRegistrosEliminados'
import ListadoProcesadosHabilitados from './ListadosDeFallecidos/ListadoProcesadosHabilitados'
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Title from 'components/TitleWithIcon';

import { Group, PersonAddDisabled, PeopleAlt, HighlightOff } from '@material-ui/icons';
import {Box, Tabs, AppBar, makeStyles, withStyles} from '@material-ui/core';
import MuiTab from '@material-ui/core/Tab';

const Tab = withStyles({
	root: {
	  "&$selected": {
		backgroundColor: "#1D5079",
		color: "white",
		"& .MuiListItemIcon-root": {
		  color: "white"
		}
	  },
	  "&$selected:hover": {
		backgroundColor: "#1D5079",
		color: "white",
		"& .MuiListItemIcon-root": {
		  color: "white"
		}
	  },
	  "&:hover": {
		backgroundColor: "black",
		color: "white",
		"& .MuiListItemIcon-root": {
		  color: "white"
		}
	  }
	},
	selected: {}
  })(MuiTab);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`} {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: '#D4D8E1',        
    },
    backgroundColorTab:{
        backgroundColor: '#D4D8E1',        
    }
}));

function ScrollableTabsButtonForce(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.tabValueInitial);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    var authenticated =props.authenticated;
    useEffect(() => {
        if(props.idSolicitudTSEVirtualEnviada){
            handleChange({},4)
        }
    },[props.idSolicitudTSEVirtualEnviada])
    return (
        <div className={classes.root}>
            <Title title="Módulo de Fallecidos" icon={"/menu/partner.svg"}/>
            <AppBar position="static" color="inherit" elevation={0}>
                <Tabs 
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="#ffffff"
                    textColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    <Tab label="Que tienen una coincidencia exacta" icon={<Group />} {...a11yProps(0)} />
                    <Tab label="Que tiene una coincidencia no exacta" icon={<PersonAddDisabled />} {...a11yProps(1)} />
                    <Tab label="Que no tienen coincidencias dentro del padrón" icon={<HighlightOff />} {...a11yProps(2)} />
                    <Tab label="Listado Fallecidos Procesados Empadronados" icon={<PeopleAlt />} {...a11yProps(3)} />
                    <Tab label="Listado Fallecidos Procesados No Empadronados" icon={<PeopleAlt />} {...a11yProps(4)} />
                    {/* <Tab label="Listado Fallecidos Habilitados" icon={<PeopleAlt />} {...a11yProps(5)} /> */}
                    <Tab label="Listado Registros Eliminados" icon={<PeopleAlt />} {...a11yProps(5)} />
                </Tabs>
            </AppBar>
            {/* Listado de fallecidos que tienen una coincidencia exacta */}
            <TabPanel value={value} index={0} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesQueTienenUnaCoincidenciaExacta authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* listado de fallecidos Que tiene una coincidencia no exacta*/}
            <TabPanel value={value} index={1} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesQueTieneUnaCoincidenciaNoExacta  authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de fallecidos que no tienen coincidencias dentro del padron */}
            <TabPanel value={value} index={2} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesQueNoTienenCoincidenciasDentroDelPadron authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de fallecidos, registros ya procesados empadronados */}
            <TabPanel value={value} index={3} className={classes.backgroundColorTab}>
                <ListadoProcesadosEmpadronados authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de fallecidos, registros ya procesados no empadronados*/}
            <TabPanel value={value} index={4} className={classes.backgroundColorTab}>
                <ListadoProcesadosNoEmpadronados authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de registros eliminados de origen sistema*/}
            {/* <TabPanel value={value} index={5} className={classes.backgroundColorTab}>
                <ListadoProcesadosHabilitados authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel> */}
            {/* Listado de registros eliminados de origen sistema*/}
            <TabPanel value={value} index={5} className={classes.backgroundColorTab}>
                <ListadoDeRegistrosEliminadosDeOrigenSistema authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(ScrollableTabsButtonForce);